module.exports = __webpack_public_path__ + "img/DSC_1801.babf481e.JPG";